"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Aggregation = void 0;
var Aggregation;
(function (Aggregation) {
    Aggregation["COUNT"] = "count";
    Aggregation["SUM"] = "sum";
    Aggregation["AVG"] = "avg";
    Aggregation["MIN"] = "min";
    Aggregation["MAX"] = "max";
    Aggregation["UNIQUE"] = "unique";
})(Aggregation = exports.Aggregation || (exports.Aggregation = {}));
